import { PageTitleBodyAndFooter } from 'src/app/components/Elements/PageTitleBodyAndFooter';

import { JoinWaitListForm } from '../GetStarted/Waitlist/JoinWaitListForm';

export const PromoOnboardingWaitlistRenderer = ({ dispatchRedirectToPreviousRouterLocation, previousPathName }) => {
  const handlePreviousClick = () => {
    dispatchRedirectToPreviousRouterLocation(previousPathName);
  };
  return (
    <PageTitleBodyAndFooter
      title={'Get Early Access'}
      secondaryText={`Enter your email below to be the first to find out when we're in your neighborhood.`}
      tertiaryText={''}
      showInterstitial={false}
    >
      <JoinWaitListForm isGettingStartedForm={false} onPreviousClick={handlePreviousClick} />
    </PageTitleBodyAndFooter>
  );
};
